import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface EntityTagRepository<TEntityId = string | number> {
  selectForEntity(entityId: TEntityId): Observable<string[]>;
  assign(entityId: TEntityId, tagId: string): Observable<void>;
  remove(entityId: TEntityId, tagId: string): Observable<void>;
}

export const ENTITY_TAG_REPOSITORY = new InjectionToken<EntityTagRepository>('ENTITY_TAG_REPOSITORY');
